import { createContext, useContext } from "react";
import type { InvoiceDetailStore } from "./InvoiceDetailStore";

export const InvoiceDetailContext = createContext({} as InvoiceDetailStore);
export const useInvoiceDetailStore = () => useContext(InvoiceDetailContext);
